import React from 'react';

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#F1EBDB] p-4 pb-5 text-center border-t border-gray-300">
        <p className="text-sm text-gray-700">
          Copyright 2025 Right Legal Group Limited. Right Legal Group are authorised and regulated by the Solicitors Regulation Authority. SRA Number: 607718. Right Legal Group Limited is a company registered in England and Wales. Registered address: 16 Stanier Way, Wyvern Business Park, Derby, DE21 6BF. Registration number 08276948.
        </p>
        <p className="text-sm text-gray-700 mt-2">
          For Postscrypt support, please email <a href="mailto:postscrypt@rightlegalgroup.com" target="_blank" rel="noopener noreferrer" className="text-[#F16745] hover:underline">postscrypt@rightlegalgroup.com</a>
        </p>
        {/* <a href="https://rightlegalgroup.com" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          Visit Right Legal Group
        </a> */}
    </footer>
  );
};

export default Footer;
